import styled from 'styled-components';
import { Drawer, ScrollArea } from '@mantine/core';
import { TOP_BANNER_HEIGHT } from '../Layout/Layout';
import { heading3 } from '../DesignSystem/Typography';

const HEADER_FOOTER_HEIGHT = 72;

export const StyledDrawer = styled(Drawer)<{ $withFooter?: boolean }>`
  position: absolute;
  z-index: 999;

  .mantine-Drawer-header {
    padding: var(--space-200);
    border-bottom: 1px solid var(--border-color-default);
    background: var(--black-300);
    height: ${HEADER_FOOTER_HEIGHT}px;
    margin-top: ${TOP_BANNER_HEIGHT}px;
  }

  .mantine-Drawer-content {
    background: var(--black-300);
  }

  .mantine-Drawer-body {
    ${(props) => props.$withFooter && `padding-bottom: ${HEADER_FOOTER_HEIGHT}px;`}
    ${(props) => props.size && `width: ${props.size}px;`}
  }

  .mantine-Drawer-title {
    width: 100%;
  }

  .mantine-ScrollArea-viewport {
    height: 100vh;
  }
`;

export const HeaderContainer = styled.div`
  ${heading3};
  color: var(--text-standard-primary);

  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;

  svg {
    color: var(--text-standard-secondary);
  }

  .drawerTitle {
    flex: 1;
  }
`;

export const FooterContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  align-items: center;
  padding: var(--space-200);

  height: ${HEADER_FOOTER_HEIGHT}px;
  border-top: 1px solid var(--border-color-default);
  background: var(--black-300);
`;

export const FullHeightScrollArea = styled(ScrollArea.Autosize)``;
